// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x8PBv{display:flex;flex-direction:row;gap:8px}.QKUIl{display:flex;flex-direction:row;gap:8px}.PrkjW{display:flex;flex-direction:column;gap:12px}.PjnfX{padding:24px}.PjnfX .DWzKM{padding-bottom:24px}.Cwlpd{width:168px}.mXlz5{display:flex;flex-direction:row;align-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `x8PBv`,
	"pageSubHeader": `QKUIl`,
	"pageContainer": `PrkjW`,
	"section": `PjnfX`,
	"header": `DWzKM`,
	"button": `Cwlpd`,
	"customTxnNumbersWarning": `mXlz5`
};
export default ___CSS_LOADER_EXPORT___;
